// Config options for flashcard importing
// FYI: Importing flashcards from anki (or others) takes alot of processing power & time
// used to exceed allowed time limit in the browser. Was disabled by default until more powerful server available
export const ankiImportsDisabled = false;
export const quizletImportsDisabled = true;


